<template>
  <div>
    <template>
      <h4 class="not-margin"
          :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
        <i class="fad fa-pencil-alt" :style="{ width: '25px', fontSize: '18px' }"></i>
        ແກ້ໄຂລົດຂົນສົ່ງ
      </h4>
    </template>

    <div class="field" :style="{marginTop: '20px'}">
      <div class="control">
        <label class="label">
          ທະບຽນລົດ
          <span class="text-danger">* {{ errors.first('plate_number') }}</span>
          <span class="text-danger">{{ server_errors.plate_number }}</span>
        </label>
        <input class="input" name="plate_number" v-model="truckValue.plate_number" v-validate="'required|max:50'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ປະເພດລົດ
          <span class="text-danger">* {{ errors.first('vehicle_type') }}</span>
          <span class="text-danger">{{ server_errors.vehicle_type }}</span>
        </label>
        <input class="input" name="vehicle_type" v-model="truckValue.vehicle_type" v-validate="'required|max:50'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຂະໜາດລົດ
          <span class="text-danger">{{ server_errors.size_class }}</span>
        </label>
        <div class="select">
          <select v-model="truckValue.size_class">
            <option v-for="(size, index) in sizeClassOptions" :key="index" :value="size.id">
              {{ size.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຄວາມສາມາດບັນທຸກ (kg)
          <span class="text-danger">* {{ errors.first('capacity_kg') }}</span>
          <span class="text-danger">{{ server_errors.capacity_kg }}</span>
        </label>
        <input class="input" type="number" min="0" name="capacity_kg"
               v-model="truckValue.capacity_kg" v-validate="'required'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຄວາມສາມາດບັນທຸກ (m³)
          <span class="text-danger">* {{ errors.first('capacity_cbm') }}</span>
          <span class="text-danger">{{ server_errors.capacity_cbm }}</span>
        </label>
        <input class="input" type="number" min="0" step="0.1" name="capacity_cbm"
               v-model="truckValue.capacity_cbm" v-validate="'required'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຄວາມເປັນເຈົ້າຂອງ
          <span class="text-danger">{{ server_errors.ownership }}</span>
        </label>
        <div class="select">
          <select v-model="truckValue.ownership">
            <option v-for="(item, index) in ownershipOptions" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຊື່ທີມ (ບໍ່ບັງຄັບ)
          <span class="text-danger">{{ server_errors.team_name }}</span>
        </label>
        <input class="input" name="team_name" v-model="truckValue.team_name">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">ສະຖານະ</label>
        <div class="select">
          <select v-model="truckValue.is_active">
            <option :value="true">ເປີດໃຊ້ງານ</option>
            <option :value="false">ປິດໃຊ້ງານ</option>
          </select>
        </div>
      </div>
    </div>
    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat class="form-btn-loading" :loading="btnLoading" @click="ValidateForm()">
          ບັນທຶກການແກ້ໄຂ
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import MixinFleetTrucks from '@/Mixins/Fleet/Trucks';

export default {
  props: ['truck'],
  mixins: [MixinFleetTrucks],
  methods: {
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.UpdateTruck();
        }
      });
    },
  },
  created() {
    this.server_errors = {};
    this.truckValue = {
      id: this.truck.id,
      plate_number: this.truck.plate_number,
      vehicle_type: this.truck.vehicle_type,
      size_class: this.truck.size_class,
      capacity_kg: this.truck.capacity_kg,
      capacity_cbm: this.truck.capacity_cbm,
      ownership: this.truck.ownership,
      team_name: this.truck.team_name,
      is_active: !!this.truck.is_active,
    };
  },
};
</script>

<style scoped>
</style>
